export default __webpack_public_path__ + "static/media/product-detail-01.7cd9e8c0.jpg";